module.exports = __webpack_public_path__ + "media/lobby_normal3.ec491768.mp3";